import React, { useEffect } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import isEmpty from '../../lib/isEmpty';

const PortfolioAllocation = (props) => {
  const { piechart, piecurrency } = props;

  // Color palette based on #395645
  const colorPalette = [
    "#395645",  // Original
    "#4a7559",  // Lighter
    "#2d4838",  // Darker
    "#5a8a70",  // Lighter variant
    "#1f3028",  // Much darker
    "#6fa085",  // Light variant
    "#2b3a33",  // Dark variant
    "#4d866d",  // Medium-light
  ];

  useEffect(() => {
    // Enable amCharts themes
    am4core.useTheme(am4themes_animated);

    // Set up license
    am4core.addLicense("CH123456789");

    // Create chart instance
    const chart = am4core.create("chartdiv", am4charts.PieChart);
    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    // Configure pie chart as donut
    chart.innerRadius = am4core.percent(60);

    chart.legend = new am4charts.Legend();
    chart.legend.maxHeight = 150;
    chart.legend.scrollable = true;

    const data =
      piecurrency &&
      piecurrency.length > 0 &&
      piecurrency.map((currency, index) => ({
        piecurrency: currency?.currency,
        piechart: piechart[index],
        color: colorPalette[index % colorPalette.length]
      }));

    // Set data
    chart.data = data;

    // Create series
    const series = chart.series.push(new am4charts.PieSeries());
    series.dataFields.value = "piechart";
    series.dataFields.category = "piecurrency";

    // Assign colors to the series slices
    series.slices.template.propertyFields.fill = "color";
    series.slices.template.strokeWidth = 0;

    // Configure label appearance
    series.labels.template.fill = am4core.color("#FFFFFF"); // Default label text color
    series.labels.template.fontSize = 12; // Label font size
    series.labels.template.fontWeight = "bold"; // Label font weight
    series.ticks.template.disabled = true;
    series.labels.template.disabled = true;

    // Customize legend labels and value labels
    chart.legend.labels.template.adapter.add("fill", function (fill, target) {
      if (target.dataItem && target.dataItem.dataContext.piecurrency) {
        return am4core.color("#395645"); // Match theme color
      }
      return fill;
    });

    chart.legend.valueLabels.template.adapter.add("fill", function (fill, target) {
      if (target.dataItem && target.dataItem.dataContext.piecurrency) {
        return am4core.color("#395645"); // Match theme color
      }
      return fill;
    });

    // Add custom colors to labels
    series.labels.template.adapter.add("fill", function (fill, target) {
      if (target.dataItem) {
        return target.dataItem.dataContext.color;
      }
      return fill;
    });

    // Calculate total value from piechart array
    const totalValue = piechart && piechart.length > 0 
      ? piechart.reduce((sum, value) => sum + (parseFloat(value) || 0), 0)
      : 0;

    // Add center text for total value and portfolio info
    const centerLabel = chart.seriesContainer.createChild(am4core.Label);
    centerLabel.text = `$${totalValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    centerLabel.horizontalCenter = "middle";
    centerLabel.verticalCenter = "middle";
    centerLabel.textAlign = "center";
    centerLabel.fontSize = 16;
    centerLabel.fontWeight = "bold";
    centerLabel.fill = am4core.color("#395645");
    centerLabel.dy = 0;

    // Clean up function for useEffect
    return () => {
      chart.dispose();
    };
  }, [piechart, piecurrency]); // Update chart when piechart or piecurrency changes

  return (
    <div id="chartdiv" style={{ width: "100%", height: "500px" }}></div>
  );
};

export default PortfolioAllocation;
